/**
 * Bordered container that groups label/value rows inside appointment modals and popups.
 */

import React from 'react';
import { Flex, theme } from 'antd';

interface AppointmentDetailsBoxProps {
  children: React.ReactNode;
  /** Uses the lighter fill background instead of the container background. */
  filled?: boolean;
  style?: React.CSSProperties;
}

/** Groups detail rows in a 1px secondary-bordered, large-radius box with vertical spacing. */
export const AppointmentDetailsBox: React.FC<AppointmentDetailsBoxProps> = ({ children, filled = false, style }) => {
  const { token } = theme.useToken();

  return (
    <Flex
      vertical
      gap={token.marginSM}
      style={{
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadiusLG,
        padding: `${token.paddingSM}px ${token.paddingMD}px`,
        background: filled ? token.colorFillQuaternary : token.colorBgContainer,
        minWidth: 0,
        ...style
      }}
    >
      {children}
    </Flex>
  );
};
